import Swal from 'sweetalert2'

import { faLink, faUnlink } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button } from '@domain-group/suit-theme'

import ButtonWithOauth from '@components/ButtonWithOAuth'

import type { UseAccountingIntegrationPayload } from '@hooks/useAccountingIntegration'

import handleCallbackAction from '@functions/handleCallbackAction'

type DisconnectIntegration = UseAccountingIntegrationPayload['callbacks']['disconnectIntegration']

const confirmDisconnect = (disconnectFn: DisconnectIntegration, name: string) => {
  const payload = {
    callbacks: {
      action: disconnectFn,
    },
    toastText: 'Disconnected',
  }

  Swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, disconnect me.',
      icon: 'warning',
      showCancelButton: true,
      text: `Are you sure? This will disconnect all agencies currently connected to this ${name} organisation.`,
      title: `Disconnect from ${name}?`,
    })
    .then(({ value }) => {
      if (value){
        handleCallbackAction(payload)
      }
    })
}

const buttonTitles = {
  xero: 'Xero',
}

interface AccountingIntegrationButtonProps {
  accountingPayload: UseAccountingIntegrationPayload,
  disabled: boolean,
}

const AccountingIntegrationButton = (props: AccountingIntegrationButtonProps) => {
  const { accountingPayload, disabled } = props

  const {
    accountingPlatformApi,
    authProviderKey,
    callbacks: { disconnectIntegration },
    disconnecting,
    hasActiveSession,
    loadingIntegrationData,
    selectedAgencyId,
  } = accountingPayload

  // @ts-expect-error TS7053
  const buttonTitle = buttonTitles[accountingPlatformApi] || 'Xero'

  if (hasActiveSession){
    return (
      <Button
        buttonStyle="secondaryEdit"
        disabled={disabled}
        // @ts-expect-error TS2322
        ghost
        icon={<FontAwesomeIcon icon={faUnlink} />}
        loading={disconnecting}
        onClick={() => confirmDisconnect(disconnectIntegration, buttonTitle)}
        size="medium"
      >
        {`Disconnect from ${buttonTitle}`}
      </Button>
    )
  }

  return (
    <ButtonWithOauth
      authProviderKey={authProviderKey}
      buttonStyle="secondaryEdit"
      disabled={disabled}
      icon={<FontAwesomeIcon icon={faLink} />}
      loading={loadingIntegrationData}
      queryParams={{
        agency_id: selectedAgencyId,
        redirect: window.location.href,
      }}
      size="medium"
      // @ts-expect-error
      width="auto"
    >
      {hasActiveSession ? `Connected to ${buttonTitle}` : `Connect to ${buttonTitle}`}
    </ButtonWithOauth>
  )
}

export default AccountingIntegrationButton
